import { evaluadorMercantil, ID_MERCANTIL } from './mercantil';
import { evaluadorSancor, ID_SANCOR } from './sancor';
import { evaluadorSanCristobal, ID_SAN_CRISTOBAL } from './sanCristobal';

export const EVALUADORES_COTIZACION = {
   [ID_MERCANTIL]: evaluadorMercantil,
   [ID_SANCOR]: evaluadorSancor,
   [ID_SAN_CRISTOBAL]: evaluadorSanCristobal,
};

export const evaluarAntesDeCotizar = (idCompania, datosCotizacion) => {
   const evaluador = EVALUADORES_COTIZACION[idCompania];
   if (!evaluador?.evaluarAntesDeCotizar) {
      return { disponible: true, motivo: null };
   }
   return evaluador.evaluarAntesDeCotizar(datosCotizacion);
};

export const obtenerEvaluador = (idCompania) =>
   EVALUADORES_COTIZACION[idCompania] ?? null;

export const buildEntradaNoDisponible = (compania, motivo) => ({
   id_compania: compania.id_compania,
   nombre: compania.nombre,
   logo: compania.logo ?? null,
   color: compania.color ?? null,
   motivo,
});
